// converted to JavaScript from https://github.com/larshp/codemirror-abap
// Author: Lars Hvam
// Original Author: Lars Hvam

// import CodeMirror from "codemirror/lib/codemirror";

CodeMirror.defineMode("abap", () => {
  const COMMENT = "comment";
  const STRING = "string";
  const NUMBER = "number";
  const KEYWORD = "keyword";
  const OPERATOR = "operator";
  const ERROR = "error";
  const PUNCTUATION = "punctuation";

  function setupKeywords(str) {
    let list = str.split(" ");
    let ret = {};
    for (let i = 0; i < list.length; ++i) {
      ret[list[i]] = true;
    }
    return ret;
  }

  var keywords = setupKeywords("IS NOT EQ GE GT REF " +
    "AND ALIAS ALIASES APPEND ASCENDING ASSERT ASSIGN ASSIGNING " +
    "BACK BEGIN BINARY BLOCK BOUND BY BYTE " +
    "CALL CHANGING CHECK CLEAR CLOSE CNT COLLECT COMMIT CHARACTER " +
    "CORRESPONDING COMMUNICATION COMPONENT COMPUTE CONCATENATE CONDENSE CONSTANTS " +
    "CONTROLS CONVERT CREATE CURRENCY " +
    "DATA DESCENDING DEFAULT DEFINE DEFINITION DEFERRED DELETE DESCRIBE DETAIL DIVIDE DURATION " +
    "DELETING " +
    "END ENDEXEC ENDFUNCTION " +
    "ENDCLASS ENDMETHOD ENDFORM " +
    "CLASS METHOD FORM " +
    "ENDINTERFACE ENDMODULE " +
    "ENDPROVIDE ENDSELECT ENDTRY ENDWHILE EVENT EVENTS EXEC EXIT EXPORT " +
    "EXPORTING EXTRACT EXCEPTION EXCEPTIONS " +
    "FRAME FETCH FIELDS FINAL FORMAT FREE FROM FUNCTION FIND FOR " +
    "GENERATE " +
    "HARMLESS HIDE " +
    "IMPORT IMPORTING INDEX INFOTYPES INITIAL INITIALIZATION " +
    "INTERFACE INTERFACES INPUT INSERT IMPLEMENTATION INTO " +
    "LEAVE LEVEL LIKE LINE LOAD LOCAL LENGTH LEFT LEADING " +
    "METHOD MESSAGE METHODS MODIFY MODULE MOVE MULTIPLY MATCH " +
    "NEW " +
    "OBJECT OBLIGATORY OVERLAY OPTIONAL OTHERS OCCURRENCES OCCURS OFFSET " +
    "PACK PARAMETERS PERFORM POSITION PRIVATE PROGRAM PROTECTED PROVIDE PUBLIC " +
    "RADIOBUTTON RAISING RANGES RECEIVE RECEIVING REDEFINITION REF " +
    "REFERENCE REFRESH REGEX REJECT RESULTS " +
    "REPLACE REPORT RESERVE RESTORE RETURN RETURNING RISK ROLLBACK READ " +
    "SCAN SCROLL SEARCH SELECT SEPARATED SHIFT SHORT SINGLE SKIP SORT SORTED SPLIT STANDARD " +
    "STATICS STEP STOP STRUCTURE SUBMATCHES SUBMIT SUBTRACT SUMMARY SUPPRESS SECTION " +
    "TABLES TABLE TESTING TIMES TITLE TITLEBAR TO TRANSFER TRANSFORMATION TRANSLATE TYPES TYPE " +
    "UNASSIGN ULINE UNPACK UPDATE USING " +
    "VALUE " +
    "WHEN WHILE WINDOW WRITE WHERE WITH " +
    "ADD-CORRESPONDING AUTHORITY-CHECK " +
    "BREAK-POINT CLASS-DATA " +
    "CLASS-METHOD CLASS-METHODS " +
    "DIVIDE-CORRESPONDING DISPLAY DISPLAY-MODE " +
    "EDITOR-CALL END-OF-DEFINITION END-OF-PAGE END-OF-SELECTION " +
    "FIELD-GROUPS FIELD-SYMBOLS " +
    "FUNCTION-POOL LEFT-JUSTIFIED LINE-COUNT LINE-SIZE " +
    "MESSAGE-ID MOVE-CORRESPONDING MULTIPLY-CORRESPONDING " +
    "NEW-LINE NEW-PAGE NEW-SECTION " +
    "NO-GAP NO-SIGN " +
    "NO-ZERO PRINT-CONTROL " +
    "READ-ONLY RIGHT-JUSTIFIED " +
    "SELECT-OPTIONS SELECTION-SCREEN START-OF-SELECTION " +
    "SUBTRACT-CORRESPONDING SYNTAX-CHECK " +
    "SYNTAX-TRACE SYSTEM-CALL TOP-OF-PAGE TYPE-POOL TYPE-POOLS " +
    "AT CASE CATCH CONTINUE DO ELSEIF ELSE ENDAT ENDCASE ENDDO ENDIF " +
    "ENDLOOP ENDON IF LOOP ON RAISE TRY WORK " +

     "SCIENTIFIC_WITH_LEADING_ZERO SCALE_PRESERVING_SCIENTIFIC RMC_COMMUNICATION_FAILURE END-ENHANCEMENT-SECTION MULTIPLY-CORRESPONDING "+
     "SUBTRACT-CORRESPONDING VERIFICATION-MESSAGE DIVIDE-CORRESPONDING ENHANCEMENT-SECTION CURRENCY_CONVERSION RMC_SYSTEM_FAILURE START-OF-SELECTION " +
     "MOVE-CORRESPONDING RMC_INVALID_STATUS CUSTOMER-FUNCTION END-OF-DEFINITION ENHANCEMENT-POINT SYSTEM- S ADD-CORRESPONDING SCALE_PRESERVING "+
     "SELECTION-SCREEN CURSOR-SELECTION END-OF-SELECTION LOAD-OF-PROGRAM SCROLL-BOUNDARY SELECTION-TABLE IMPLEMENTATIONS PARAMETER-TABLE " +
     "RIGHT-JUSTIFIED UNIT_CONVERSION AUTHORITY-CHECK LIST-PROCESSING SIGN_AS_POSTFIX COL_BACKGROUND IMPLEMENTATION INTERFACE-POOL TRANSFORMATION " +
     "IDENTIFICATION ENDENHANCEMENT LINE-SELECTION LEFT-JUSTIFIED SELECT-OPTIONS SELECTION-SETS DECIMAL_SHIFT VALUE-REQUEST CHAIN-REQUEST " +
     "FUNCTION-POOL FIELD-SYMBOLS FUNCTIONALITY INVERTED-DATE SELECTION-SET CLASS-METHODS OUTPUT-LENGTH CLASS-CODING COL_NEGATIVE ERRORMESSAGE " +
     "HELP-REQUEST NO-EXTENSION NO-TOPOFPAGE REDEFINITION DISPLAY-MODE ENDINTERFACE EXIT-COMMAND FIELD-SYMBOL NO-SCROLLING SHORTDUMP-ID " +
     "ACCESSPOLICY CLASS-EVENTS COL_POSITIVE DECLARATIONS ENHANCEMENTS FILTER-TABLE SWITCHSTATES SYNTAX-CHECK TRANSPORTING ASYNCHRONOUS SYNTAX-TRACE " +
     "TOKENIZATION USER-COMMAND WITH-HEADING ABAP-SOURCE BREAK-POINT CHAIN-INPUT COMPRESSION FIXED-POINT NEW-SECTION NON-UNICODE OCCURRENCES RESPONSIBLE " +
     "SYSTEM-CALL TRACE-TABLE ABBREVIATED CHAR-TO-HEX END-OF-FILE ENDFUNCTION ENVIRONMENT ASSOCIATION COL_HEADING EDITOR-CALL END-OF-PAGE ENGINEERING " +
     "IMPLEMENTED INTENSIFIED RADIOBUTTON SYSTEM-EXIT TOP-OF-PAGE TRANSACTION APPLICATION CONCATENATE DESTINATION ENHANCEMENT IMMEDIATELY NO-GROUPING " +
     "PRECOMPILED REPLACEMENT TITLE-LINES ACTIVATION BYTE-ORDER CLASS-POOL CONNECTION CONVERSION DEFINITION DEPARTMENT EXPIRATION INHERITING " +
     "NO-HEADING PERFORMING QUEUE-ONLY RIGHTSPACE SCIENTIFIC STATUSINFO STRUCTURES SYNCPOINTS WITH-TITLE ATTRIBUTES BOUNDARIES CLASS-DATA COL_NORMAL " +
     "DESCENDING INTERFACES LINE-COUNT NON-UNIQUE PRESERVING SELECTIONS STATEMENTS SUBROUTINE TRUNCATION TYPE-POOLS ARITHMETIC BACKGROUND " +
     "ENDPROVIDE IDENTIFIER INDEX-LINE OBLIGATORY PARAMETERS PERCENTAGE PUSHBUTTON RESOLUTION COMPONENTS DEALLOCATE DISCONNECT DUPLICATES " +
     "FIRST-LINE HEAD-LINES NO-DISPLAY OCCURRENCE RESPECTING RETURNCODE SUBMATCHES TRACE-FILE ASCENDING BYPASSING ENDMODULE EXCEPTION EXCLUDING EXPORTING " +
     "INCREMENT MATCHCODE PARAMETER PARTIALLY PREFERRED REFERENCE REPLACING RETURNING SELECTION SEPARATED SPECIFIED STATEMENT TIMESTAMP TYPE-POOL ACCEPTING " +
     "APPENDAGE ASSIGNING COL_GROUP COMPARING CONSTANTS DANGEROUS IMPORTING INSTANCES LEFTSPACE LOG-POINT QUICKINFO READ-ONLY SCROLLING SQLSCRIPT STEP-LOOP " +
     "TOP-LINES TRANSLATE APPENDING AUTHORITY CHARACTER COMPONENT CONDITION DIRECTORY DUPLICATE MESSAGING RECEIVING SUBSCREEN ACCORDING COL_TOTAL END-LINES " +
     "ENDMETHOD ENDSELECT EXPANDING EXTENSION INCLUDING INFOTYPES INTERFACE INTERVALS LINE-SIZE PF-STATUS PROCEDURE PROTECTED REQUESTED RESUMABLE RIGHTPLUS " +
     "SAP-SPOOL SECONDARY STRUCTURE SUBSTRING TABLEVIEW NUMOFCHAR ADJACENT ANALYSIS ASSIGNED BACKWARD CHANNELS CHECKBOX CONTINUE CRITICAL DATAINFO DURATION " +
     "ENCODING ENDCLASS FUNCTION LEFTPLUS LINEFEED OVERFLOW RECEIVED SKIPPING SORTABLE STANDARD SUBTRACT SUPPRESS TABSTRIP TITLEBAR TRUNCATE UNASSIGN WHENEVER " +
     "ANALYZER COALESCE COMMENTS CONDENSE DECIMALS DEFERRED ENDWHILE EXPLICIT KEYWORDS MESSAGES POSITION PRIORITY RECEIVER RENAMING TIMEZONE TRAILING ALLOCATE " +
     "CENTERED CIRCULAR CONTROLS CURRENCY DELETING DESCRIBE DISTANCE ENDCATCH EXPONENT EXTENDED GENERATE IGNORING INCLUDES INTERNAL MAJOR-ID MODIFIER NEW-LINE " +
     "OPTIONAL PROPERTY ROLLBACK STARTING SUPPLIED ABSTRACT CHANGING CONTEXTS CREATING CUSTOMER DATABASE DAYLIGHT DEFINING DISTINCT DIVISION ENABLING ENDCHAIN " +
     "ESCAPING HARMLESS IMPLICIT INACTIVE LANGUAGE MINOR-ID MULTIPLY NEW-PAGE NO-TITLE POS_HIGH SEPARATE TEXTPOOL TRANSFER SELECTOR DBMAXLEN ITERATOR SELECTOR " +
     "ARCHIVE BIT-XOR BYTE-CO COLLECT COMMENT CURRENT DEFAULT DISPLAY ENDFORM EXTRACT LEADING LISTBOX LOCATOR MEMBERS METHODS NESTING POS_LOW PROCESS PROVIDE " +
     "RAISING RESERVE SECONDS SUMMARY VISIBLE BETWEEN BIT-AND BYTE-CS CLEANUP COMPUTE CONTROL CONVERT DATASET ENDCASE FORWARD HEADERS HOTSPOT INCLUDE INVERSE " +
     "KEEPING NO-ZERO OBJECTS OVERLAY PADDING PATTERN PROGRAM REFRESH SECTION SUMMING TESTING VERSION WINDOWS WITHOUT BIT-NOT BYTE-CA BYTE-NA CASTING CONTEXT " +
     "COUNTRY DYNAMIC ENABLED ENDLOOP EXECUTE FRIENDS HANDLER HEADING INITIAL LOGFILE MAXIMUM MINIMUM NO-GAPS NO-SIGN PRAGMAS PRIMARY PRIVATE REDUCED REPLACE " +
     "REQUEST RESULTS UNICODE WARNING ALIASES BYTE-CN BYTE-NS CALLING COL_KEY COLUMNS CONNECT ENDEXEC ENTRIES EXCLUDE FILTERS FURTHER HELP-ID LOGICAL MAPPING " +
     "MESSAGE NAMETAB OPTIONS PACKAGE PERFORM RECEIVE STATICS VARYING BINDING CHARLEN GREATER XSTRLEN ACCEPT APPEND DETAIL ELSEIF ENDING ENDTRY FORMAT FRAMES " +
     "GIVING HASHED HEADER IMPORT INSERT MARGIN MODULE NATIVE OBJECT OFFSET REMOTE RESUME SAVING SIMPLE SUBMIT TABBED TOKENS UNIQUE UNPACK UPDATE WINDOW " +
     "ACTUAL ASPECT CENTER CURSOR DELETE DIALOG DIVIDE DURING ERRORS EVENTS EXTEND FILTER HANDLE HAVING IGNORE LITTLE MEMORY NO-GAP OCCURS OPTION PERSON PLACES " +
     "PUBLIC REDUCE REPORT RESULT SINGLE SORTED SWITCH SYNTAX TARGET VALUES WRITER ASSERT BLOCKS BOUNDS BUFFER CHANGE COLUMN COMMIT CONCAT COPIES CREATE " +
     "DEFINE ENDIAN ESCAPE EXPAND KERNEL LAYOUT LEGACY LEVELS NUMBER OUTPUT RANGES READER RETURN SCREEN SEARCH SELECT SHARED SOURCE STABLE STATIC SUBKEY " +
     "SUFFIX TABLES UNWIND ASSIGN BACKUP BEFORE BINARY BIT-OR CLIENT CODING COMMON DEMAND DYNPRO EXCEPT EXISTS EXPORT FIELDS GLOBAL GROUPS LENGTH " +
     "LOCALE MEDIUM METHOD MODIFY NESTED REJECT SCROLL SUPPLY SYMBOL ENDFOR STRLEN ALIGN BEGIN BOUND ENDAT ENTRY EVENT FINAL FLUSH GRANT INNER SHORT USING " +
     "WRITE AFTER BLACK BLOCK CLOCK COLOR COUNT DUMMY EMPTY ENDDO ENDON INDEX INOUT LEAVE LEVEL LINES MODIF ORDER OUTER RANGE RESET RETRY RIGHT SMART SPLIT " +
     "STYLE THROW UNDER UNTIL UPPER UTF-8 EXACT FIRST FOUND GROUP LLANG OTHER SPOOL TYPES VALID WHILE " +
     "ALPHA BOXED CHAIN COVER EQUIV FIELD FLOOR LOWER NODES PAGES PRINT ROUND SPACE SPOTS STAMP STATE TASKS " +
     "TIMES TRMAC ULINE UNION VALUE WIDTH EQUAL LOG10 TRUNC BLOB CASE CEIL CLOB COND EXIT FILE GAPS HOLD INCL INTO KEEP KEYS LAST LINE LONG LPAD MAIL MODE OPEN " +
     "READ ROWS TEST THEN ZERO AREA BACK BADI BYTE CAST EDIT EXEC FAIL FIND FKEQ FONT FREE GKEQ HIDE INIT ITNO LATE LOOP MAIN MARK MOVE NEXT NULL RISK ROLE UNIT WAIT " +
     "ZONE BASE CALL CODE DATA DATE FKGE GKGE HIGH KIND LEFT LIST MASK MESH NAME NODE PACK PAGE POOL SEND SIGN SIZE SOME STOP TASK TEXT TIME USER VARY WITH WORD " +
     "CONV COPY DEEP ELSE FORM FROM HINT ICON JOIN LIKE LOAD ONLY PART SCAN SKIP SORT TYPE UNIX VIEW WHEN WORK ACOS ASIN ATAN COSH EACH FRAC LESS RTTI SINH SQRT TANH " +
     "AVG BIT DIV ISO LET OUT PAD SQL ALL CPI END LOB LPI MAX MIN NEW OLE RUN SET ABS ADD AND BIG FOR HDB JOB LOW NOT SAP TRY VIA XML ANY GET IDS KEY MOD OFF " +
     "PUT RAW SUM TAB XSD COS EXP LOG SIN TAN XOR CO CP ID NS OR BT CA CS NA NB IN LT NE OF PF AS CN LE NP UP NO"
  );

  function isKeyword(stream) {
    let next = stream.next();
    let back = 0;
    while (true) {
      if (!next) {
        break;
      } else if (next === " " || next === "." || next === "," || next === ":") {
        stream.backUp(1);
        break;
      } else {
        back++;
      }
      next = stream.next();
    }

    let match = keywords.propertyIsEnumerable(stream.current().toUpperCase());
    if (match === false) {
      stream.backUp(back);
    }
    return match;
  }

  function isOperator(str) {
    const OPERATORS = "?= = > <> < + - * / &&";

    str = str.trim();

    let list = OPERATORS.split(" ");

    for (let i = 0; i < list.length; i++) {
      if (str === list[i]) {
        return true;
      }
    }
    return false;
  }

  function isPunctuation(str) {
    const PUNCTUATIONS = "[ , . : ; ( ) ]";
    str = str.trim();

    let list = PUNCTUATIONS.split(" ");
    return list.includes(str);
  }

  return {
    startState: function() {
      return {
        mode: false
      };
    },
    token: function(stream, state) {
      if (stream.eatSpace()) {
        return undefined;
      }

      if (isKeyword(stream)) {
        return KEYWORD;
      } else if (stream.match(/\b\d+\b/)) {
        stream.match(/^\d+/);
        return NUMBER;
      } else if (stream.match(/^##\w+/)) {
// pragmas
        return COMMENT;
      }

      let ch = stream.next();
      let peek = stream.peek();
      if (peek === undefined) {
        peek = "";
      }

      if ((ch === "*" && stream.column() === 0) || ch === "\"") {
        stream.skipToEnd();
        return COMMENT;
      } else if (isOperator(ch + peek)) {
        return OPERATOR;
      } else if (isPunctuation(ch)) {
        return PUNCTUATION;
      } else if (ch === "\'") {
        let next = "";
        while (next !== undefined) {
          if (next === "\'") {
            state.mode = false;
            break;
          }
          next = stream.next();
        }
        return STRING;
      } else if (ch === "|") {
        let next = "";
        while (next !== undefined) {
          if (next === "|") {
            state.mode = false;
            break;
          }
          next = stream.next();
        }
        return STRING;
      } else {
        stream.eatWhile(/(\w|<|>)/);
        return ERROR;
      }
    }
  };
});

CodeMirror.defineMIME("text/abap", "abap");
